import { useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { UseMutationResult, UseQueryResult } from '@tanstack/react-query';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons';

import { Toast } from '@app/components';

export const useRemoveActivityMutationEffect = (
  removeMutation: UseMutationResult,
  listQuery: UseQueryResult
) => {
  const { $t } = useIntl();
  const renderErrorToast = useCallback(() => {
    Toast({
      type: 'error',
      title: $t({
        id: 'recentActivity.somethingWentWrongRemove',
        defaultMessage:
          'Something went wrong while removing your item(s). Please, try again.',
      }),
      icon: faTimesCircle,
    });
  }, [$t]);

  useEffect(() => {
    if (removeMutation.isSuccess || removeMutation.isError) {
      if (removeMutation.isError) {
        renderErrorToast();
      }

      listQuery.refetch();
      removeMutation.reset();
    }
  }, [listQuery, removeMutation, renderErrorToast]);
};
